/**
 * @copyright WaterStreet. All rights reserved.
 */

/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
	Component
} from '@angular/core';
import {
	FormlyFieldConfig
} from '@ngx-formly/core';
import {
	CommonTableComponent
} from '@shared/components/common-table/common-table.component';
import {
	CommonTablePageDirective
} from '@shared/directives/common-table-page.directive';
import {
	AnyHelper
} from '@shared/helpers/any.helper';
import {
	ICommonTable
} from '@shared/interfaces/application-objects/common-table.interface';
import {
	IDynamicComponentContext
} from '@shared/interfaces/application-objects/dynamic-component-context.interface';
import {
	ResolverService
} from '@shared/services/resolver.service';
import {
	SiteLayoutService
} from '@shared/services/site-layout.service';

/* eslint-enable max-len */

@Component({
	selector: 'commission-disbursement-retry-expand',
	templateUrl: './commission-disbursement-retry-expand.component.html',
	styleUrls: [
		'./commission-disbursement-retry-expand.component.scss'
	]
})

/**
 * A component representing an instance of the commission disbursement
 * component.
 *
 * @export
 * @class CommissionDisbursementRetryExpandComponent
 */
export class CommissionDisbursementRetryExpandComponent
	extends CommonTablePageDirective
{
	/**
	 * Initializes a new instance of the
	 * CommissionDisbursementRetryExpandComponent class.
	 *
	 * @param {SiteLayoutService} siteLayoutService
	 * The site layout service used in this component to get its data.
	 * @param {ResolverService} resolver
	 * The resolver service used for dynamic logic and business rules.
	 * @memberof CommissionDisbursementRetryExpandComponent
	 */
	public constructor(
		public siteLayoutService: SiteLayoutService,
		public resolver: ResolverService)
	{
		super(resolver);
	}

	/**
	 * Gets or sets the context that will be set when implementing this
	 * as a dynamic component.
	 *
	 * @type {IDynamicComponentContext<CommonTableComponent, any>}
	 * @memberof CommissionDisbursementRetryExpandComponent
	 */
	public context: IDynamicComponentContext<CommonTableComponent, any>;

	/**
	 * Gets or sets the layout schema object to be used in the
	 * dynamic formly form fields.
	 *
	 * @type {object}
	 * @memberof SearchFilterComponent
	 */
	public layoutSchema: FormlyFieldConfig[];

	/**
	 * Implements the on initialization interface.
	 *
	 * @memberof CommissionDisbursementRetryExpandComponent
	 */
	public ngOnInit()
	{
		const commonTable: ICommonTable =
			<ICommonTable>this.context.data.commonTable;

		const selectedItem: any =
			this.context.source.selectedItem;

		commonTable.actions.update.items[0].visible =
			this.canRetryPayment(selectedItem);
		commonTable.actions.update.layout[0].props.disabled =
			!this.canRetryPayment(selectedItem);

		this.loadingTableDefinitions = false;
	}

	/**
	 * Determines if retry button should be enabled or not based on the payment
	 * status.
	 *
	 * @memberof CommissionDisbursementRetryExpandComponent
	 */
	private canRetryPayment(
		selectedItem: any): boolean
	{
		if (AnyHelper.isNull(selectedItem))
		{
			return false;
		}

		return selectedItem.paymentStatus === 'Error';
	}
}